export type StoreSize = {
  label: string;
  cartUrl: string;
};

export type StoreProduct = {
  slug: string;
  name: string;
  color?: string;
  price: number | null;
  description: string;
  images: string[];
  sizes: StoreSize[];
  category: 'tops' | 'bottoms' | 'outerwear' | 'accessories';
};

const SHOPIFY = 'https://s9yn3n-tu.myshopify.com/cart';

export const storeProducts: StoreProduct[] = [
  // ===== TOPS =====
  {
    slug: 'black-enhance-polo',
    name: 'Enhance Polo',
    color: 'Black',
    price: 35,
    description:
      'Tailored performance polo in matte black. Embroidered Enhance Companies crest. The signature piece.',
    images: ['/store/black-polo-1.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45591707320422:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45591671832678:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45591868801126:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45591873749094:1?channel=buy_button` },
    ],
  },
  {
    slug: 'white-enhance-polo',
    name: 'Enhance Polo',
    color: 'White',
    price: 35,
    description:
      'Crisp white performance polo with embroidered Enhance Companies crest. Office ready, range tested.',
    images: ['/store/white-polo-1.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45594045546598:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45594045710438:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45594065240166:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45594065993830:1?channel=buy_button` },
    ],
  },
  {
    slug: 'enhance-tshirt',
    name: 'Enhance Companies Tee',
    price: 35,
    description:
      'Premium cotton tee with Enhance Companies branding. The everyday staple.',
    images: ['/store/tshirt-1.png', '/store/tshirt-2.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45594095747174:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45594095845478:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45594096107622:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45594096402534:1?channel=buy_button` },
    ],
  },
  {
    slug: 'after-hours-tee',
    name: 'Enhance After Hours Tee',
    price: 35,
    description:
      'Late-night graphic tee. Cotton-blend, oversized fit.',
    images: ['/store/after-hours-tee-1.png', '/store/after-hours-tee-2.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45604799545446:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45604799676518:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45604799807590:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45604799873126:1?channel=buy_button` },
    ],
  },
  {
    slug: 'bunny-tee',
    name: 'Enhance Bunny Tee',
    price: 35,
    description:
      'Limited graphic tee with the signature Enhance bunny.',
    images: ['/store/bunny-tee-1.png', '/store/bunny-tee-2.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45607716683878:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45607718617190:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45607718748262:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45607719370854:1?channel=buy_button` },
    ],
  },
  {
    slug: 'derby-tee',
    name: 'Enhance Derby Tee',
    price: 35,
    description:
      'Equestrian-inspired derby graphic tee. Premium cotton.',
    images: ['/store/derby-tee-1.png', '/store/derby-tee-2.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45613654966374:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45613656014950:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45613656899686:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45613657620582:1?channel=buy_button` },
    ],
  },
  {
    slug: 'jumping-tee',
    name: 'Enhance Jumping Tee',
    price: 35,
    description:
      'Graphic tee inspired by the jumping discipline. Premium cotton.',
    images: ['/store/jumping-tee-1.png', '/store/jumping-tee-2.png'],
    category: 'tops',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45601983201382:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45601985364070:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45601987362918:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45601988837478:1?channel=buy_button` },
    ],
  },

  // ===== OUTERWEAR =====
  {
    slug: 'enhance-hoodie',
    name: 'Enhance Companies Hoodie',
    price: 60,
    description:
      'Heavyweight pullover hoodie in deep navy. Built for late nights and long flights.',
    images: ['/store/hoodie-1.png', '/store/hoodie-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45594069532774:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45594073006182:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45594074120294:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45594075234406:1?channel=buy_button` },
    ],
  },
  {
    slug: 'enhance-quarter-zip-black',
    name: 'Enhance Quarter Zip',
    color: 'Black',
    price: 80,
    description:
      'Refined quarter-zip pullover in matte black. The boardroom layer for closers.',
    images: ['/store/quarter-zip-black-1.png', '/store/quarter-zip-black-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45594110951526:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45594114949222:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45613683114086:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45594119274598:1?channel=buy_button` },
    ],
  },
  {
    slug: 'enhance-quarter-zip-blue',
    name: 'Enhance Quarter Zip',
    color: 'Navy',
    price: 80,
    description:
      'Refined quarter-zip pullover in deep navy. Made for the long game.',
    images: ['/store/quarter-zip-blue-1.png', '/store/quarter-zip-blue-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45598068342886:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45598068408422:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45598070407270:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45598070997094:1?channel=buy_button` },
    ],
  },
  {
    slug: 'chess-club-hoodie',
    name: 'Enhance Chess Club Hoodie',
    price: 60,
    description:
      'Heavyweight pullover with the Enhance Chess Club graphic. Limited release.',
    images: ['/store/chess-hoodie-1.png', '/store/chess-hoodie-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45601130348646:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45601144799334:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45601160626278:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45601168457830:1?channel=buy_button` },
    ],
  },
  {
    slug: 'tennis-hoodie',
    name: 'EC Tennis Hoodie',
    price: 60,
    description:
      'Court-side pullover with the EC tennis graphic. Heavyweight cotton blend.',
    images: ['/store/tennis-hoodie-1.png', '/store/tennis-hoodie-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45598135910502:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45598136041574:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45598136139878:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45598136336486:1?channel=buy_button` },
    ],
  },
  {
    slug: 'logo-hoodie',
    name: 'Enhance Logo Hoodie',
    price: 60,
    description:
      'Clean logo hoodie. The Enhance crest, oversized and proud.',
    images: ['/store/logo-hoodie-1.png', '/store/logo-hoodie-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45601308082278:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45601310081126:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45601312309350:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45601314635878:1?channel=buy_button` },
    ],
  },
  {
    slug: 'polo-zip-up',
    name: 'Enhance Polo Zip Up',
    price: 55,
    description:
      'Full zip layered piece with polo styling. Refined for transitional weather.',
    images: ['/store/polo-zip-up-1.png', '/store/polo-zip-up-2.png'],
    category: 'outerwear',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45598129651814:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45598130241638:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45598130733158:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45598131159142:1?channel=buy_button` },
    ],
  },

  // ===== BOTTOMS =====
  {
    slug: 'enhance-sweatpants',
    name: 'Enhance Companies Sweatpants',
    price: 45,
    description:
      'Mid-weight French terry sweatpants. Tapered fit, branded for the inner circle.',
    images: ['/store/sweatpants-1.png'],
    category: 'bottoms',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45594079363174:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45594083426406:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45594085326950:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45594085818470:1?channel=buy_button` },
    ],
  },
  {
    slug: 'polo-sweatpants',
    name: 'Enhance Polo Sweatpants',
    price: 40,
    description:
      'Premium French terry sweatpants with polo styling. Tapered fit.',
    images: ['/store/polo-sweatpants-1.png', '/store/polo-sweatpants-2.png'],
    category: 'bottoms',
    sizes: [
      { label: 'S', cartUrl: `${SHOPIFY}/45601343996006:1?channel=buy_button` },
      { label: 'M', cartUrl: `${SHOPIFY}/45601345994854:1?channel=buy_button` },
      { label: 'L', cartUrl: `${SHOPIFY}/45601348911206:1?channel=buy_button` },
      { label: 'XL', cartUrl: `${SHOPIFY}/45601376206950:1?channel=buy_button` },
    ],
  },

  // ===== ACCESSORIES =====
  {
    slug: 'enhance-hat',
    name: 'Enhance Companies Hat',
    price: 20,
    description:
      'Structured cap with embroidered Enhance crest. One size, every occasion.',
    images: ['/store/hat-1.png', '/store/hat-2.png', '/store/hat-3.png'],
    category: 'accessories',
    sizes: [
      { label: 'One Size', cartUrl: `${SHOPIFY}/45594097746022:1?channel=buy_button` },
    ],
  },
];

export const getProductBySlug = (slug: string): StoreProduct | undefined =>
  storeProducts.find((p) => p.slug === slug);

export const productsByCategory = (cat: StoreProduct['category']): StoreProduct[] =>
  storeProducts.filter((p) => p.category === cat);

export const isAvailable = (p: StoreProduct): boolean =>
  p.price !== null && p.sizes.length > 0;
